import { request } from "./client";

export const getMarketplaceCampaigns = (_period = "3d") =>
  Promise.resolve({ campaigns: [], data: [] });

export const getMarketplaceAds = (_period = "3d") =>
  Promise.resolve({ campaigns: [], data: [] });

export const getMarketplacePricing = (_duration = "3d") =>
  Promise.resolve({ pricing: [] });

export const createCampaign = (payload) =>
  request("/marketplace/campaigns", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const getAllAdsStats = () =>
  request(`/ads`)
    .then((res) => {
      const list = Array.isArray(res) ? res : res?.data;
      return Array.isArray(list) ? list.filter(Boolean) : [];
    })
    .catch(() => []);

export const getApprovedAds = (placement = "feed") =>
  request(`/ads?placement=${placement}&status=approved`)
    .then((res) => {
      const list = Array.isArray(res) ? res : res?.data;
      return Array.isArray(list) ? list.filter(Boolean) : [];
    })
    .catch(() => []);

export const recordAdView = (adId) =>
  request(`/ads/${adId}/view`, { method: "POST" }).catch(() => {});

export const recordAdClick = (adId) =>
  request(`/ads/${adId}/click`, { method: "POST" }).catch(() => {});